import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import {
  INFO_FORM_OTHER_SETTING as FORM,
  ALERT_MAIL,
  LOGIN_IP,
  ALERT_AUTH_IDS,
  AI_OPT_OUT,
} from 'domain/system-setting/consts';
import useCheckPermissionCapi from 'services/custom-hooks/useCheckPermissionCapi';
import systemSettingActions from 'store/system-setting/actions';
import systemSettingSelectors from 'store/system-setting/selectors';
import DataSyncLoader from 'views/atoms/loader/DataSyncLoader';
import FormGroup from 'views/molecules/FormGroup/FormGroup';
import { getAccountId, getAgentFlag } from 'store/auth/selectors';
import { loadAuth } from 'services/LocalStorageService';
import OtherSettingModal from './OtherSettingModal';

const getChatSessionsUrl = () => {
  const host = (process.env.REACT_APP_CONTENTS_API_HOST || '').replace(
    /\/v1\.0\/?$/,
    ''
  );
  return `${host}/chat/v1.0/sessions`;
};

function OtherSettingContainer() {
  const dispatch = useDispatch();
  const { isLoading, data } = useSelector(
    systemSettingSelectors.getStatesOtherSetting
  );
  const accountId = useSelector(getAccountId, shallowEqual);
  const isAgentUser = useSelector(getAgentFlag, shallowEqual);

  const {
    isCapiSingleContract,
    isCapiEditPermission,
  } = useCheckPermissionCapi();

  const isWaitingAiChat = localStorage.getItem('is_waiting_ai_chat');
  const [isShowSettingModal, setShowSettingModal] = useState(false);
  const [isShowNoteAiChat, setShowNoteAiChat] = useState(false);

  const onOpenSettingModal = () => setShowSettingModal(true);
  const onHideSettingModal = () => setShowSettingModal(false);

  useEffect(() => {
    dispatch(systemSettingActions.getOtherSetting());
  }, [dispatch]);

  useEffect(() => {
    if (!isWaitingAiChat) return;

    const checkAiChatSession = async () => {
      const { accessToken } = loadAuth() || {};
      if (!accessToken) return;

      try {
        const res = await fetch(getChatSessionsUrl(), {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (res.status === 200) {
          localStorage.removeItem('is_waiting_ai_chat');
          setShowNoteAiChat(false);
        } else if (res.status === 403) {
          setShowNoteAiChat(true);
        }
      } catch {
        // Ignore network errors for silent status check
      }
    };

    checkAiChatSession();
  }, [isWaitingAiChat]);

  return (
    <DataSyncLoader isLoading={isLoading}>
      <div className="other-setting">
        {isCapiEditPermission && (
          <FormGroup
            label={FORM[ALERT_AUTH_IDS].label}
            tooltip={FORM[ALERT_AUTH_IDS].tooltip}
          >
            <div>
              {data?.userIds ? (
                data.userIds.map((user) => <div>{user}</div>)
              ) : (
                <></>
              )}
            </div>
          </FormGroup>
        )}
        <FormGroup
          label={FORM[ALERT_MAIL].label}
          tooltip={FORM[ALERT_MAIL].tooltip}
        >
          <div className="system-setting__pre-wrap">
            {data?.[ALERT_MAIL] ? data[ALERT_MAIL].replaceAll(',', '\r\n') : ''}
          </div>
        </FormGroup>
        <FormGroup label={FORM[LOGIN_IP].label}>
          <div className="system-setting__pre-wrap">
            {data?.[LOGIN_IP] ? data[LOGIN_IP].replaceAll(',', '\r\n') : ''}
          </div>
        </FormGroup>
        {!isAgentUser && (
          <FormGroup
            label={FORM[AI_OPT_OUT].label}
            tooltip={FORM[AI_OPT_OUT].tooltip}
          >
            <p className="ai-optout-status">{data?.[AI_OPT_OUT] ? '無効' : '有効'}</p>
            {isShowNoteAiChat && (
              <div className="ai-notes-wrapper">
                <p className="note-title">
                  ただいまAIアシスト機能を準備しています。
                </p>
                <p className="note-content">
                  ご利用には最大15分程度お時間がかかる場合がございます。
                  <br />
                  しばらく経ってから、画面右上のAIアシストアイコンをクリックしてください。
                </p>
              </div>
            )}
          </FormGroup>
        )}
        <Button
          size="sm"
          variant="secondary"
          disabled={isLoading}
          onClick={onOpenSettingModal}
        >
          編集
        </Button>
        {isShowSettingModal && (
          <OtherSettingModal
            isShow={isShowSettingModal}
            isCapiSingleContract={isCapiSingleContract}
            isCapiEditPermission={isCapiEditPermission}
            onHide={onHideSettingModal}
            data={data}
            accountId={accountId}
          />
        )}
      </div>
    </DataSyncLoader>
  );
}

export default OtherSettingContainer;
